import { render } from "./overBudget.vue?vue&type=template&id=2199c2d8"
import script from "./overBudget.vue?vue&type=script&lang=js"
export * from "./overBudget.vue?vue&type=script&lang=js"
script.render = render

export default script